import Vue from 'vue';
import Vuex from 'vuex';
import form from './modules/form';
import scheduling from './modules/scheduling';
import payments from './modules/payments';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    response: {},
    fieldErrors: [],
    cookie: {},
    cookieAccepted: false,
    sig: null
  },
  mutations: {
    changeTest(state) {
        state.test = !state.test ? true : false;
    },
    addField(state, field) {
      Vue.set(state.response, field.fieldId, field);
    },
    updateField(state, field) {
      const currentField = state.response[field.fieldId];
      currentField.value = field.value;
    },
    addFieldError(state, error) {
      const fieldErrors = state.fieldErrors;
      fieldErrors.push(error);
    },
    updateFieldError(state, error) {
      const fieldError = state.fieldErrors.find(fError => fError.fieldId === error.fieldId);
      fieldError.error = error.error;
    },
    addM360Cookie(state, cookie) {
      state.cookie = cookie;
    },
    acceptM360Cookie(state) {
      state.cookieAccepted = !state.cookieAccepted;
    },
    setEvent(state, event) {
      state.event = event;
    },
    removeField(state, field) {
      delete state.response[field.fieldId];
    },
    setSig(state, id) {
      state.sig = id;
    }
  },
  getters: {
    response: state => state.response,
    getFieldById: state => id => state.response[id],
    getFieldErrorById: state => id => state.fieldErrors.find(error => error.fieldId === id),
    fieldsWithErrors: state => state.fieldErrors.filter(field => field.error),
    cookie: state => state.cookie,
    cookieAccepted: state => state.cookieAccepted,
    event: state => state.event,
    sig: state => state.sig,
  },
  modules: {
    form,
    scheduling,
    payments
  },
});
